import {
    //createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const todoAdapter = createEntityAdapter({})

const initialState = todoAdapter.getInitialState()

export const todoApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTodos: builder.query({
            query: () => ({
                url: '/todos',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedTodos = responseData.map(todo => {
                    todo.id = todo._id
                    return todo
                });
                return todoAdapter.setAll(initialState, loadedTodos)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Todo', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Todo', id }))
                    ]
                } else return [{ type: 'Todo', id: 'LIST' }]
            }
        }),
        getTodosPastdue: builder.query({
            query: (arg) => {
                const { due_date, user_id } = arg
                return {
                    url: `todos/pastdue/${due_date}/${user_id}`,
                }
            },
            providesTags: ['PastDue'],
        }),
        addTodo: builder.mutation({
            query: (todo) => ({
                url: '/todos',
                method: 'POST',
                body: todo
            }),
            invalidatesTags: [
                { type: 'Todo', id: "LIST" }, {type: 'PastDue'}
            ]
        }),
        updateTodo: builder.mutation({
            query: (todo) => ({
                url: '/todos',
                method: 'PATCH',
                body: todo
            }),
            invalidatesTags: [
                { type: 'Todo', id: "LIST" }, {type: 'PastDue'}
            ]
        }),
        deleteTodo: builder.mutation({
            query: ({ id }) => ({
                url: `/todos/${id}`,
                method: 'DELETE',
                body: id
            }),
            invalidatesTags: [
                { type: 'Todo', id: "LIST" }, {type: 'PastDue'}
            ]
        }),
        completeTodo: builder.mutation({
            query: (todo) => ({
                url: '/todos/completed',
                method: 'PATCH',
                body: todo
            }),
            invalidatesTags: [
                { type: 'Todo', id: "LIST" }, {type: 'PastDue'}
            ]
        }),
    })
})

export const {
    useGetTodosQuery,
    useGetTodosPastdueQuery,
    useAddTodoMutation,
    useUpdateTodoMutation,
    useDeleteTodoMutation,
    useCompleteTodoMutation,
} = todoApiSlice


// do we need other the code, like other slices???